import translationFactory from '../../services/translation-service';

const useTranslation = () => {
  return translationFactory();
};

export default useTranslation;
